export function normalizePathItemName(name: string): string {
  return name.replaceAll('\t', ' ')
}

/** Trailing whitespace removed (the API rejects it); leading is kept */
export function nameForServer(name: string): string {
  return name.replace(/\s+$/u, '')
}
